import React, { useEffect } from "react";
import VariablePicker from "../VariablePicker/VariablePicker";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { Dialog, DialogTitle } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { TextInput } from "../TextInput/NewTextInput";
import Close from "@material-ui/icons/Close";

export default function VariableMapping({
  action,
  variables,
  setOpen,
  variableRender,
  setOpenVariable,
  setMappingData,
  mappingData,
  index,
  setIndex,
}) {
  // control of fields or set field
  useEffect(() => {
    if (index !== -1) {
      action.fields.multiVariable.value =
        action.fields.destinationVariable.value[index].key;
      action.fields.multiVariable.htmlValue =
        action.fields.destinationVariable.value[index].key;

      action.fields.mapToVariable.value =
        action.fields.destinationVariable.value[index].toVariable;

    } else {
      if (action.fields.multiVariable) {
        action.fields.multiVariable = { value: "", htmlValue: "" };
        action.fields.mapToVariable = { value: "", type: 'VARIABLEPICKER' };
      }
    }
  }, [index]);

  //add variable mapping data
  function handleAdd() {
    if (action.fields.multiVariable?.value) {
      setMappingData((oldArr) => [
        ...oldArr,
        {
          key: action.fields.multiVariable?.value,
          toVariable: action.fields.mapToVariable?.value,
        },
      ]);
      setOpen(false);
      setIndex(-1);
    }
  }

  // delete item in array
  function handleDelete() {
    mappingData.splice(index, 1);
    setMappingData(mappingData);
    setOpen(false);
    setIndex(-1);
  }

  //update item in array
  function handleUpdate() {
    mappingData[index].key = action.fields.multiVariable.value;
    mappingData[index].toVariable = action.fields.mapToVariable.value;
    setOpen(false);
    setIndex(-1);
  }

  return (
    <Dialog id="autom-addNew-modal" data-test="autom-add-new" open={true}>
      <DialogTitle id="alert-dialog-title">
        <Button
          style={{ float: "right" }}
          data-test="cancelautom-button"
          onClick={() => setOpen(false)}
        >
          <Close />
        </Button>
      </DialogTitle>
      <DialogContent>
        <div style={{ width: "400px" }}>
          <div className="form-element">
            Key
            <TextInput
              action={action}
              inputName="multiVariable"
              isRequired={false}
              setOpenVariable={setOpenVariable}
              variables={variables}
            />
          </div>
          <div className="form-element">
            Map to Variable
            <VariablePicker
              action={action}
              inputName="mapToVariable"
              variables={variables}
              setOpenVariable={setOpenVariable}
              variableRender={variableRender}
              isRequired={false}
            />
          </div>
        </div>
      </DialogContent>
      <DialogActions
        style={{
          justifyContent: index === -1 ? "flex-end" : "space-between",
          padding: "8px 24px 16px 24px",
        }}
      >
        {index === -1 ? (
          <Button variant="outlined"
            style={{ float: "right", backgroundColor: "#46474E", borderRadius: "2px", color: "#fff", width: "45%", border: "none" }}
            onClick={handleAdd}>
            Add
          </Button>
        ) : (
          <>
            <Button variant="outlined"
              style={{ float: "left", backgroundColor: "#D75E5E", borderRadius: "2px", color: "#fff", width: "45%", border: "none" }}
              onClick={handleDelete}>
              Delete
            </Button>
            <Button variant="outlined"
              style={{ float: "right", backgroundColor: "#46474E", borderRadius: "2px", color: "#fff", width: "45%", border: "none" }}
              onClick={handleUpdate}>
              Edit
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
}
